import { h, Component } from 'preact';
import Dialog from 'preact-material-components/Dialog';
import Snackbar from 'preact-material-components/Snackbar';
import { connect } from 'redux-zero/preact';
import actions from '../../actions';
import TextField from 'preact-material-components/TextField';
import 'preact-material-components/Dialog/style.css';
import 'preact-material-components/Snackbar/style.css';
import 'preact-material-components/TextField/style.css';


export class Entry extends Component {

	state = {
		currentEntry: {},
		loading: false,
		errors: {},
		settings: {}
	};

	componentDidMount() {
		this.update();
	}

	update() {
		this.props.getSettings().then(() => {
			if (this.props.settings) {
				const dates = Object.keys(this.props.settings).filter(key => key.match(/^\d{6}$/) && parseInt(this.props.settings[key]) === 1).sort();
				let maxDate = dates[dates.length-1].match(/^(\d{4})(\d{2})$/).map(item => parseInt(item));

				if (maxDate[2] === 12) {
					maxDate = new Date(maxDate[1] + 1, 0, 1, 0, 0, 0, 0);
				}
				else {
					maxDate = new Date(maxDate[1], maxDate[2], 1, 0, 0, 0, 0);
				}
				maxDate.setTime(maxDate.getTime() - 1);
				console.error(maxDate);
				const month = maxDate.getMonth() + 1;
				this.setState({
					settings: this.props.settings,
					minDate: dates[0].replace(/^(\d{4})(\d{2})$/, '$1-$2-01'),
					maxDate: `${maxDate.getFullYear()}-${month < 10 ? ('0' + month) : month}-${maxDate.getDate()}`
				});
			}
		});
	}

	dataIsAllowed = date => {
		const key = date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1$2');
		return (key in this.state.settings) && parseInt(this.state.settings[key]);
	};

	open(currentEntry = {}, afterSuccess = null) {
		this.setState({
			currentEntry
		});
		this.dialogRef.MDComponent.show();
		this.afterSuccess = afterSuccess;
	}

	onCancel = () => {
		this.setState({
			currentEntry: {}
		});
		this.dialogRef.MDComponent.close();
	};

	onInput = field => e => {
		this.setState({
			currentEntry: {
				...this.state.currentEntry,
				[field]: e.target.value
			}
		});
	};

	onSave = async () => {
		if (this.isInsertMode()) {
			return await this.onInsert();
		}
	};

	onInsert = async () => {
		const looking = 'Szukam: ' + this.state.currentEntry.data + ' w bazie ' + JSON.stringify(Object.keys(this.state.settings));
		console.warn(looking);
		this.setState({ loading: true });
		const errors = {};
		['opis', 'miejsce', 'czas', 'data'].forEach(item => {
			if (!this.state.currentEntry[item]) {
				errors[item] = 'Proszę uzupełnić pole';
			}
		});
		if (this.state.currentEntry.data && !this.dataIsAllowed(this.state.currentEntry.data)) {
			errors.data = 'Nie ma możliwości dodawać/modyfikować rekordów z tego miesiąca';
		}
		if (Object.keys(errors).length > 0) {
			this.setState({
				errors,
				loading: false
			});
			return;
		}
		try {
			if (this.state.currentEntry.nr_rek) {
				const entry = this.state.currentEntry;
				if (entry.szef_ok === '-1') {
					entry.szef_ok = '0';
				}
				if (entry.bhp_ok === '-1') {
					entry.bhp_ok = '0';
				}
				await this.props.updateEntry(entry);
				this.snackbarRef.MDComponent.show({
					message: 'Wpis zaktualizowany pomyślnie!'
				});
			}
			else {
				await this.props.addEntry(this.state.currentEntry);
				this.snackbarRef.MDComponent.show({
					message: 'Wpis dodany pomyślnie!'
				});
			}
			this.dialogRef.MDComponent.close();
			if (typeof this.afterSuccess === 'function') {
				this.afterSuccess();
			}
		} catch (err) {
			console.error(err);
			this.setState({
				errors: err
			});
		}
		this.setState({ loading: false });

	};

	isInsertMode = () => this.state.currentEntry.pracownik_id === undefined ||
		(
			this.state.currentEntry.pracownik_id === this.props.user.nr && parseInt(this.state.currentEntry.szef_ok) <= 0
		);

	render(props) {

		return (<div>
			<Dialog
				ref={dialog => this.dialogRef = dialog}
				style={{ backgroundColor: 'transparent' }}
			>
				<Dialog.Body>
					{this.isInsertMode() && (
						<div>
							<form>
								{this.state.errors.error &&
								<p style={{ color: 'red', textAlign: 'center' }}>{this.state.errors.error}</p>}

								<TextField
									value={this.state.currentEntry.opis}
									onInput={this.onInput('opis')}
									label="Opis realizowanych prac"
									margin="normal"
									className="mt-1"
									width="100%"
									outerStyle={{ width: '100%' }}
									autoFocus
								/>
								{this.state.errors.opis && <small style={{ color: 'red' }}>{this.state.errors.opis}</small>}
								<TextField
									value={this.state.currentEntry.miejsce}
									onInput={this.onInput('miejsce')}
									label="Wskazanie miejsca wykonywanych czynności w terenie"
									margin="normal"
									className="mt-1"
									width="100%"
									outerStyle={{ width: '100%' }}
									autoFocus
								/>
								{this.state.errors.miejsce && <small style={{ color: 'red' }}>{this.state.errors.miejsce}</small>}
								<TextField
									value={this.state.currentEntry.data}
									onInput={this.onInput('data')}
									label="Data"
									margin="normal"
									type="date"
									className="mt-1"
									width="100%"
									min={this.state.minDate}
									max={this.state.maxDate}
									outerStyle={{ width: '100%' }}
									autoFocus
								/>
								{this.state.errors.data && <small style={{ color: 'red' }}>{this.state.errors.data}</small>}
								<TextField
									value={this.state.currentEntry.czas}
									onInput={this.onInput('czas')}
									label="Ilość minut"
									margin="normal"
									type="number"
									className="mt-1"
									width="100%"
									outerStyle={{ width: '100%' }}
									autoFocus
								/>
								{this.state.errors.czas && <small style={{ color: 'red' }}>{this.state.errors.czas}</small>}
							</form>
						</div>
					)}
				</Dialog.Body>
				<Dialog.Footer>
					<Dialog.FooterButton onClick={this.onCancel}>Anuluj</Dialog.FooterButton>
					<Dialog.FooterButton onClick={this.onSave}>Zapisz</Dialog.FooterButton>
				</Dialog.Footer>
			</Dialog>
			<Snackbar
				ref={snackbar => this.snackbarRef = snackbar}
			/>
		</div>);
	}

}

export default connect(({ user, addEntry, updateEntry, settings, getSettings }) => ({
	user,
	addEntry,
	updateEntry,
	settings,
	getSettings
}), actions)(Entry);



// WEBPACK FOOTER //
// ./components/entry/index.js